export default __webpack_public_path__ + "static/media/19.8e0c59ac.jpg";